import { CheckoutState } from '../../state';
import { shouldDisplayAttendeeBasicInfoQuestionsAfterPayment } from '../../utils/statsig';
import { getIsPaymentView } from '../routing';

export const shouldPrefillFirstAttendeeBasicInfoQuestions = (
    state: CheckoutState,
) =>
    !(
        getIsPaymentView(state) &&
        shouldDisplayAttendeeBasicInfoQuestionsAfterPayment()
    );
